<template>
    <div>
        <modal @closed="close"
               cancel-button-text="Cancel"
               class="text-center"
               custom-class="max-w-md">
               <p v-text="$t('DELIVERY_ADDRESS_DELETE_MODAL_TEXT')"></p>
               <template slot="actions-prefix">
                    <button
                        @click.prevent="deleteAddress"
                        class="btn"
                        v-html="$t('REMOVE')">
                    </button>
                </template>
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/structure/Modal';

export default {
    name: 'DeleteAddressModal',
    props: {
        addressId: {
            requires: true,
            type: Number,
        },
        isGifting: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        deleteAddress() {
            if (this.isGifting) {
                this.$store.dispatch('address/deleteGiftingAddress', this.addressId)
                    .then(() => {
                        this.close();
                        this.$store.dispatch('address/fetchAllGiftingAddresses', true);
                    }).catch((err) => console.log(err));
            } else {
                this.$store.dispatch('address/deleteAddress', this.addressId)
                    .then(() => {
                        this.close();
                        this.$store.dispatch('subscription/fetchAllSubscriptions', true);
                    }).catch((err) => console.log(err));
            }
        },

        close() {
            this.$emit('closed');
        },
    },
    components: {
        Modal,
    },
};
</script>

<style scoped>
    .btn {
        font-weight: 400;
        font-family: gillsans;
        padding: 0.5rem 2rem 0.5rem 2rem;
        display: inline-block;
        border-radius: 0.25rem;
        min-width: 300px;
        max-height: 50px;
        color: #fff;
        background-color: #5AB5D9;
        border-color: #5AB5D9;
        margin-top: 1rem;
        margin-bottom: 20px;
        margin-left: 25px;
    }

</style>
